import { usePaginatedApi } from "../../../swr/useApi";
import { loyaltyService } from "../../api_client";
import type {
    LoyaltyPointTransactionDto,
} from "../../../api";

interface LoyaltyPointsQueryDto {
    page?: number;
    pageSize?: number;
    search?: string;
    sortBy?: string;
    sortOrder?: "asc" | "desc";
    isExpired?: boolean;
    isRedeemed?: boolean;
}

export function useLoyaltyPointsTransactions(
    query?: LoyaltyPointsQueryDto
) {
    return usePaginatedApi<LoyaltyPointTransactionDto, LoyaltyPointsQueryDto>({
        key: "loyalty-points-transactions",
        serviceMethod: async (queryParams) => {
            return await loyaltyService.getMyLoyaltyPoints(queryParams);
        },
        query: query,
    });
}
